import React, { useEffect, useState } from 'react'
import { Row, Card, Col, Carousel, Typography, Skeleton } from 'antd'
import type { HeadlineProps } from '../../Types/Dashboard'
// import { XMLParser } from 'fast-xml-parser'
import axios from 'axios'
// types.ts
export interface FeedItemAuthor {
    name: string
}

export interface FeedItemAttachment {
    url: string
}

export interface FeedItem {
    id: string
    url: string
    title: string
    content_text: string
    content_html: string
    image: string
    date_published: string
    authors?: FeedItemAuthor[]
    attachments?: FeedItemAttachment[]
}

export interface RSSFeed {
    version: string
    title: string
    home_page_url: string
    feed_url: string
    language: string
    description: string
    items: FeedItem[]
}
const { Title, Paragraph } = Typography
const FEED_URL = 'https://rss.app/feeds/v1.1/_aZ8WD8r2UbqQg4tV.json'
const TWENTY_MINUTES = 20 * 60 * 1000
const HeadLines = ({
    greetingText,
    backgroundImageUrl,
    dashboardNewsInfo,
}: HeadlineProps): React.ReactElement => {
    const [feedItems, setFeedItems] = useState<FeedItem[]>([])
    const [loading, setLoading] = useState(false)

    // const onChangeHeadLine = (number: number): void => {
    //     SetHeadlineNumber(number)
    // }

    const fetchFeed = async (): Promise<void> => {
        setLoading(true)
        try {
            const res = await axios.get<RSSFeed>(FEED_URL)
            setFeedItems(res.data.items)
        } catch (error) {
            console.error('Error fetching RSS feed:', error)
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        void fetchFeed() // initial fetch

        const intervalId = setInterval(() => {
            void fetchFeed()
        }, TWENTY_MINUTES)

        return () => {
            clearInterval(intervalId)
        } // cleanup on unmount
    }, [])

    return (
        <>
            {/* Inline CSS for dot color */}

            <style>
                {`
                  .custom-carousel .slick-dots li button {
                    background-color: #999 !important;
                  }
                  .custom-carousel .slick-dots li.slick-active button {
                    background-color: #1890ff !important;
                  }
                `}
            </style>

            <Card style={{ width: '100%' }}>
                <Skeleton active loading={loading}>
                    <Row justify="center" align="middle">
                        <Col span={24}>
                            <Carousel
                                autoplay
                                dots
                                arrows
                                className="custom-carousel"
                            >
                                {feedItems.map((item) => (
                                    <div
                                        key={item.id}
                                        style={{
                                            padding: '16px 0',
                                            marginBottom: 20,
                                        }}
                                    >
                                        <Row
                                            gutter={[16, 16]}
                                            align="middle"
                                            justify="center"
                                        >
                                            <Col xs={24} md={10}>
                                                <img
                                                    src={item.image}
                                                    alt={item.title}
                                                    style={{
                                                        width: '100%',
                                                        maxHeight: '150px',
                                                        objectFit: 'cover',
                                                        borderRadius: '12px',
                                                    }}
                                                />
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <div
                                                    style={{
                                                        paddingBottom: 50,
                                                    }}
                                                >
                                                    <Title
                                                        level={4}
                                                        style={{
                                                            marginBottom: 8,
                                                        }}
                                                    >
                                                        {/* {item.title?.length > 1
                                                        ? `${item.title?.slice(0, 60)}...`
                                                        : item.title} */}
                                                        {item.title}
                                                    </Title>
                                                    <Paragraph
                                                        style={{
                                                            marginBottom: 16,
                                                        }}
                                                    >
                                                        {item?.content_text
                                                            ?.length > 80
                                                            ? `${item?.content_text?.slice(0, 80)}...`
                                                            : item.content_text}
                                                    </Paragraph>
                                                    <a
                                                        href={item.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Read more →
                                                    </a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                            </Carousel>
                        </Col>
                    </Row>
                </Skeleton>
            </Card>
        </>
    )
}

export default HeadLines
